import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";
import { IPurchaseOrder, IPurchaseOrders, IPurchaseOrderState } from "../interfaces/PurchaseOrder/IPurchaseOrder";
import { IPurchaseOrderDetail, IPurchaseOrderDetails, IPurchaseOrderDetailState } from "../interfaces/PurchaseOrder/IPurchaseOrderDetail";

const initialState: IPurchaseOrderDetailState = {
    purchaseOrderDetails: [],
    purchaseOrderDetail: {
        id: 0,
        purchaseOrderId: 0,
        type: '',
        itemName: '',
        itemCost: 0.00,
        itemDescription: '',
        quantity: 0,
        shippingType: '',
        freightOnBoard: false,
        shipDate: new Date(),
        surcharge: 0,
        epaNumber: '',
        activeIngrediant: '',
        activePest: '',
        rei: '',
        chemicalType: '',
        amountOrdered: 0,
        purchaseOrder: null
    }
}

export const purchaseOrderSlice = createSlice({
    name: 'purchaseOrderDetailSlice',
    initialState,
    reducers: {
        setPurchaseOrderDetail: (state, action: PayloadAction<IPurchaseOrderDetail>) => {
            console.log("PAYLOAD", action.payload);
            state.purchaseOrderDetail = action.payload;
        },
        setPurchaseOrderDetails: (state, action: PayloadAction<IPurchaseOrderDetails>) => {
            state.purchaseOrderDetails = action.payload;
        },
        setPurchaseOrderDetailState: (state, action: PayloadAction<IPurchaseOrderDetailState>) => {
            state.purchaseOrderDetail = action.payload.purchaseOrderDetail;
            state.purchaseOrderDetails = action.payload.purchaseOrderDetails;
        }
    }
})

export const { setPurchaseOrderDetail, setPurchaseOrderDetails, setPurchaseOrderDetailState } = purchaseOrderSlice.actions;

export const selectPurchaseOrder = (state: RootState) => state.purchaseOrder.purchaseOrder;
export const selectPurchaseOrders = (state: RootState) => state.purchaseOrder.purchaseOrders;
export const selectPurchaseOrderState = (state: RootState) => state.purchaseOrder;

export default purchaseOrderSlice.reducer;